










































import Vue from 'vue';
import ItemIconTooltip from '@/old/items/ItemIconTooltip.vue';
import SpriteIcon from '@/components/util/SpriteIcon.vue';
import ICashShopEntry from '@/models/items/ICashShop';
import IJob from '@/models/jobs/IJob';

export default Vue.extend({
    components: {
        ItemIconTooltip,
        SpriteIcon,
    },
    props: {
        entry: {
            type: Object as () => ICashShopEntry,
            required: true,
        },
        origin: {
            type: String,
            default: '',
        },
        //  Package contents are usually only sold via their package — their
        //  individual sale status is noise there.
        hideSaleStatus: {
            type: Boolean,
            default: false,
        },
        //  Package-only members carry price 0; hide the meaningless "0 QC".
        hideZeroPrice: {
            type: Boolean,
            default: false,
        },
        //  Base classes the entry is restricted to; empty = usable by everyone.
        restrictedJobs: {
            type: Array as () => IJob[],
            default: () => [],
        },
    },
    computed: {
        techMode(): boolean {
            return this.$store.state.techMode;
        },
        isPackage(): boolean {
            //  Game rule: a cashpackagetable entry, not _ItemSort, marks packages.
            return this.entry.isPackage;
        },
    },
});
